export default __webpack_public_path__ + "static/media/restaurationen-komposit.ce6b16ad.png";